module.exports = __webpack_public_path__ + "images/emoji/speak_no_evil.2a9d71e3f4e864220de3.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/speak_no_evil.png
// module id = B+o1
// module chunks = 24